// extracted by mini-css-extract-plugin
module.exports = {"rtbCard":"RtbCard_rtbCard__qujYv","specification":"RtbCard_specification__xDhUB"};